module.exports = __webpack_public_path__ + "src/assets/games/43/403.jpg";